import { render, staticRenderFns } from "./searchDialog.vue?vue&type=template&id=620df946&scoped=true"
import script from "./searchDialog.vue?vue&type=script&lang=js"
export * from "./searchDialog.vue?vue&type=script&lang=js"
import style0 from "./searchDialog.vue?vue&type=style&index=0&id=620df946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620df946",
  null
  
)

export default component.exports